import { vec3 } from 'gl-matrix';
export default function getEffectiveSpacingAlongDirection(volume, direction) {
    const { direction: volumeDirection, spacing } = volume;
    const iVector = volumeDirection.slice(0, 3);
    const jVector = volumeDirection.slice(3, 6);
    const kVector = volumeDirection.slice(6, 9);
    const dotI = vec3.dot(iVector, direction) / spacing[0];
    const dotJ = vec3.dot(jVector, direction) / spacing[1];
    const dotK = vec3.dot(kVector, direction) / spacing[2];
    return 1 / Math.sqrt(dotI * dotI + dotJ * dotJ + dotK * dotK);
}
